define.alias("shared/components/shared/base-time-picker", "calendar/components/shared/base-time-picker");